import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { useIsShoppingAssistantWebEnabled } from '../../../../composables/useIsShoppingAssistantWebEnabled'

/**
 * Gates the gifting PLP pill entry point (AI-2014).
 *
 * Visible only when the web shopping assistant is enabled (experiment +
 * opened countries + route, see useIsShoppingAssistantWebEnabled) and the
 * per-country gifting pill flag FF_SHOPPING_ASSISTANT_GIFTING_PLP_PILL_ENABLED_COUNTRIES
 * includes the current market.
 */
export function useShoppingAssistantGiftingPlpPillEnabled() {
  const { market } = useMarketplace()
  const { FF_SHOPPING_ASSISTANT_GIFTING_PLP_PILL_ENABLED_COUNTRIES } =
    useRuntimeConfig().public
  const isAssistantWebEnabled = useIsShoppingAssistantWebEnabled()
  const isGiftingPlpPillEnabled = computed(() =>
    Boolean(
      FF_SHOPPING_ASSISTANT_GIFTING_PLP_PILL_ENABLED_COUNTRIES?.includes(
        market.countryCode,
      ),
    ),
  )

  const isEnabled = computed(
    () => isAssistantWebEnabled.value && isGiftingPlpPillEnabled.value,
  )

  return { isEnabled }
}
